import { routingAuthorityNames } from "@/services/consts";
import AccessChecker from "@/router/accessChecker";
import { getSiteLink } from "@/router/links";
import SelfOffice from "@/types/SelfOffice"
import i18n from '@/lang/i18n';

export type SidebarLink = {
  name: string,
  path: string,
  icon: string,
  showLink?: boolean,
  extarnal_link?: boolean,
  childLinks?: Array<SidebarLink>,
  tooltip?: string,
}

class SidebarLinksCreator {

  accessChecker: AccessChecker
  office: SelfOffice

  constructor(accessChecker: AccessChecker, office: SelfOffice) {
    this.accessChecker = accessChecker
    this.office = office
  }

  get getLinks() {
    return this.getVisibleLinks(this.getExistLinks())
  }

  getExistLinks(): Array<SidebarLink> {
    return [
      this.createSideBarLinkBySiteLink({
        name: "Dashboard",
        title: i18n.global.t('sideMenue.dashboard'),
        icon: "mdi-chart-line",
      }),
      {
        name: i18n.global.t('sideMenue.firmware.firmware'),
        path: "#",
        icon: "mdi-tools",
        childLinks: [
          this.createSideBarLinkBySiteLink({
            name: "Firmwares",
            title: i18n.global.t('sideMenue.firmware.firmwareList'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "FirmwareDevices",
            title: i18n.global.t('sideMenue.firmware.FirmwareUpdate'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "FirmwareBulkUpdateList",
            title: i18n.global.t('sideMenue.firmware.FirmwareBulkUpdateList'),
        }),
        ]
      },
      {
        name: i18n.global.t('sideMenue.dailyReport.dailyReport'),
        path: "#",
        icon: "mdi-note-text",
        childLinks: [
          this.createSideBarLinkBySiteLink({
            name: "DailyReport",
            title: i18n.global.t('sideMenue.dailyReport.dailyReportOutput'),
            tooltip: i18n.global.t('sideMenue.tooltips.dailyReport.dailyReportOutput'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "DailyReportLayout",
            title: i18n.global.t('sideMenue.dailyReport.dailyReportLayout'),
            tooltip: i18n.global.t('sideMenue.tooltips.dailyReport.dailyReportLayout'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "UnexpectedEventAndAlertStatuseList",
            title: i18n.global.t('sideMenue.dailyReport.UnexpectedEventAndAlertStatuseList'),
            tooltip: i18n.global.t('sideMenue.tooltips.dailyReport.UnexpectedEventAndAlertStatuseList'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "VehicleMileageCorrection",
            title: i18n.global.t('sideMenue.dailyReport.mileageCorrection'),
            tooltip: i18n.global.t('sideMenue.tooltips.dailyReport.mileageCorrection'),
          }),
        ],
      },
      this.createSideBarLinkBySiteLink({
        name: "Every24hoursReport",
        title: i18n.global.t('sideMenue.every24HoursReport'),
        icon: "mdi-hours-24",
        tooltip: i18n.global.t('sideMenue.tooltips.every24HoursReport'),
      }),
      this.createSideBarLinkBySiteLink({
        name: "MonthlyReport",
        title: i18n.global.t('sideMenue.monthryReport'),
        icon: "mdi-note-multiple",
        tooltip: i18n.global.t('sideMenue.tooltips.monthryReport'),
      }),
      {
        name:  i18n.global.t('sideMenue.TemperatureSensor.title'),
        path: "#",
        icon: "mdi-thermometer",
        childLinks: [
          this.createSideBarLinkBySiteLink({
            name: "TemperatureSensorCharts",
            title: i18n.global.t('sideMenue.TemperatureSensor.TemperatureSensor'),
            tooltip: i18n.global.t('sideMenue.tooltips.TemperatureSensor.TemperatureSensor'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "TemperaturInformationNumerical",
            title: i18n.global.t('sideMenue.TemperatureSensor.TemperaturInformationNumerical'),
            tooltip: i18n.global.t('sideMenue.tooltips.TemperatureSensor.TemperaturInformationNumerical'),
          }),
        ],
      },
      {
        name:  i18n.global.t('sideMenue.safeDrivingReport'),
        path: "#",
        icon: "mdi-alert",
        childLinks: [
          this.createSideBarLinkBySiteLink({
            name: "SafeDrivingReport",
            title: i18n.global.t('sideMenue.safeDrivingReport'),
            tooltip: i18n.global.t('sideMenue.tooltips.safeDrivingReport'),
          }),
        ],
      },
      this.createSideBarLinkBySiteLink({
        name: "CvrConvert",
        title: i18n.global.t('sideMenue.cvr'),
        icon: "mdi-video",
        tooltip: i18n.global.t('sideMenue.tooltips.cvr'),
      }),
      {
        name: i18n.global.t('sideMenue.settings.title'),
        path: "#",
        icon: "mdi-cog",
        childLinks: [
          {
            name: i18n.global.t('sideMenue.settings.accountSettings'),
            path: "#",
            icon: "",
            childLinks: [
              this.createSideBarLinkBySiteLink({
                name: "Accounts",
                title: i18n.global.t('sideMenue.settings.account'),
                tooltip : i18n.global.t('sideMenue.tooltips.settings.account')
              }),
              this.createSideBarLinkBySiteLink({
                  name: "RoleAssaignment",
                  title: i18n.global.t('sideMenue.settings.roleAssaignment'),
                  tooltip: i18n.global.t('sideMenue.tooltips.settings.roleAssaignment'),
              }),
              this.createSideBarLinkBySiteLink({
                  name: "UserRoles",
                  title: i18n.global.t('sideMenue.settings.userRoles'),
                  tooltip: i18n.global.t('sideMenue.tooltips.settings.userRoles'),
              }),
            ],
          },
          this.createSideBarLinkBySiteLink({
            name: "TenkoAssociation",
            title: i18n.global.t('sideMenue.settings.tenkoAssociation'),
            tooltip: i18n.global.t('sideMenue.tooltips.settings.tenkoAssociation'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "Vehicle",
            title: i18n.global.t('sideMenue.settings.vehicle'),
            tooltip: i18n.global.t('sideMenue.tooltips.settings.vehicle'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "DeviceList",
            title: i18n.global.t('sideMenue.settings.device'),
            tooltip: i18n.global.t('sideMenue.tooltips.settings.device'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "GpsTrackerProvisioning",
            title: i18n.global.t('sideMenue.settings.gpsTrackerProvisioning'),
            tooltip: i18n.global.t('sideMenue.tooltips.settings.gpsTrackerProvisioning'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "SubManagementOffices",
            title: i18n.global.t('sideMenue.settings.subManagementOffice'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "OperationOfficeEditForm",
            title: i18n.global.t('sideMenue.settings.operationOffice'),
            tooltip: i18n.global.t('sideMenue.tooltips.settings.operationOffice'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "OperationOfficeList",
            title: i18n.global.t('sideMenue.settings.operationOffice'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "Spot",
            title: i18n.global.t('sideMenue.settings.spot'),
            tooltip: i18n.global.t('sideMenue.tooltips.settings.spot'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "SafeDrivingSetting",
            title: i18n.global.t('sideMenue.settings.drivingScore'),
            tooltip: i18n.global.t('sideMenue.tooltips.settings.drivingScore'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "Groups",
            title: i18n.global.t('sideMenue.settings.group'),
            tooltip: i18n.global.t('sideMenue.tooltips.settings.group'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "InstallationOffice",
            title: i18n.global.t('sideMenue.settings.installationOffice'),
            tooltip: i18n.global.t('sideMenue.tooltips.settings.installationOffice'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "AllowAccessOffice",
            title: i18n.global.t('sideMenue.settings.allowAccessOffice'),
            tooltip: i18n.global.t('sideMenue.tooltips.settings.allowAccessOffice'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "Departments",
            title: i18n.global.t('sideMenue.settings.department'),
            tooltip: i18n.global.t('sideMenue.tooltips.settings.department'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "GpsTrackerSettingList",
            title: i18n.global.t('sideMenue.settings.gpsTrackerSetting'),
            tooltip: i18n.global.t('sideMenue.tooltips.settings.gpsTrackerSetting'),
          }),
        ],
      },
      {
        name: i18n.global.t('sideMenue.downloadData.downloadData'),
        path: "#",
        icon: "mdi-cloud-download",
        childLinks: [
          this.createSideBarLinkBySiteLink({
            name: "CsvDataExport",
            title: i18n.global.t('sideMenue.downloadData.csvDataExport'),
            tooltip: i18n.global.t('sideMenue.tooltips.csvDataExport'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "DownloadData",
            title: i18n.global.t('sideMenue.downloadData.downloadDataList'),
            tooltip: i18n.global.t('sideMenue.tooltips.downloadData.downloadDataList'),
          }),
          this.createSideBarLinkBySiteLink({
            name: "DownloadDataHistories",
            title: i18n.global.t('sideMenue.downloadData.downloadDataHistory'),
            tooltip: i18n.global.t('sideMenue.tooltips.downloadData.downloadDataHistory'),
          }),
        ],
      },
      this.createSideBarLinkBySiteLink({
        name: "DataLinkage",
        title: i18n.global.t('sideMenue.dataLinkage'),
        icon: "mdi-share-variant",
        tooltip: i18n.global.t('sideMenue.tooltips.dataLinkage'),
      }),
      this.createSideBarLinkBySiteLink({
        name: "AuditLog",
        title: i18n.global.t('sideMenue.auditLog'),
        icon: "mdi-history",
        tooltip: i18n.global.t('sideMenue.tooltips.auditLog'),
      }),
      {
        name: i18n.global.t('sideMenue.trackingService'),
        path: this.getTrackingServiceLink(),
        icon: "mdi-map-marker",
        extarnal_link: true,
        showLink: this.hasUserAccessTo(routingAuthorityNames.TrackingService),
        childLinks: [],
      }
    ];
  }

  hasUserAccessTo(authorityKey: string): boolean {
    return this.accessChecker.hasUserAccessTo(authorityKey)
  }

  isItManagementOffice(): boolean {
    return this.accessChecker.isItManagementOffice()
  }

  getTrackingServiceLink() {
    let path = process.env.VUE_APP_DOCOMAP_URL ?? '';
    if (!this.hasUserAccessTo("octlink.fleet_tracking_service.read")) return path;

    if (this.isItManagementOffice() || this.accessChecker.isItSubManagementOffice()) {
      return process.env.VUE_APP_FLEET_TRACKING_SERVICE_URL ?? '';
    }

    if (this.office.tracking_service == 'octlink') {
      path = process.env.VUE_APP_FLEET_TRACKING_SERVICE_URL ?? '';
    }
    if (this.office.tracking_service == 'docomap') {
      path = process.env.VUE_APP_DOCOMAP_URL ?? '';
    }
    return path
  }

  getVisibleLinks(sidebarLinks: Array<SidebarLink>): Array<SidebarLink> {
    if (this.accessChecker.hasUserAdministratorAccess()) {
      return sidebarLinks;
    }
    return sidebarLinks.filter(link => {
        return link.showLink || link.childLinks?.some(childLink => this.hasVisibleChildLinks(childLink));
      })
      .map(link => {
        if (link.childLinks) {
          link.childLinks = this.getVisibleLinks(link.childLinks);
        }
        return link;
      });
  }

  hasVisibleChildLinks(link: SidebarLink): boolean {
    if (link.showLink) {
      return true;
    }
    if (link.childLinks) {
      return link.childLinks.some(childLink => this.hasVisibleChildLinks(childLink));
    }
    return false;
  }

  createSideBarLinkBySiteLink({
    name,
    title,
    icon,
    tooltip,
  }: {
    name: string;
    title: string;
    icon?: string;
    tooltip?: string;
  }): SidebarLink {
    const siteLink = getSiteLink(name);
    if (!siteLink) {
      throw new Error('Not found link');
    }

    let showLink = siteLink.accessCheckHandler(this.accessChecker);
    if (name == 'Dashboard' && this.accessChecker.isItInstallationOffice()) {
      showLink = false
    }

    return {
      name: title,
      icon: icon ?? '',
      path: "/" + siteLink.path,
      showLink: showLink,
      childLinks: [],
      tooltip: tooltip ?? '',
    };
  }
}

export default SidebarLinksCreator
